import {
  getCustomerDetail,
  getCustomerPersonList
} from '#api/confirmation_forms';
import { usePatchMemberAllowSelfScheduling } from '#api/member';
import { useToast } from '#providers/ToastProvider';
import { PrevHeaderBarWithTitleTemplate } from '#templates';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import {
  Required,
  Section,
  Text
} from 'src/shared/components/client-registration/styles';
import { Tab } from 'src/shared/components/tab/Tab';
import { Tooltip } from 'src/shared/components/tooltip/Tooltip';

export const DashboardSettingPage = () => {
  const personId = sessionStorage.getItem('personId');

  const { data } = useQuery(
    ['COACH_ALL_RECORDS'],
    () =>
      getCustomerPersonList({
        personId: personId || '',
        offset: 1
      }),
    {
      enabled: !!personId
    }
  );

  const confirmationFormId = data ? data.data[0]?.id : '';

  const { data: customerDetail } = useQuery(
    ['customerDetail', personId, confirmationFormId],
    () =>
      getCustomerDetail({
        personId: personId || '',
        id: confirmationFormId || ''
      }),
    {
      enabled: !!personId && !!confirmationFormId
    }
  );

  const allowSelfSchedulingTab = { 네: true, 아니요: false };

  const initialAllowSelfScheduling = customerDetail
    ? customerDetail.registeredLectures[0].allowSelfScheduling
    : false;

  const [allowSelfScheduling, setAllowSelfScheduling] = useState<boolean>(
    initialAllowSelfScheduling
  );

  const { showToast } = useToast();

  const navigate = useNavigate();

  const { mutate } = usePatchMemberAllowSelfScheduling({
    onSuccess: () => {
      showToast({
        type: 'success',
        message: '회원 설정이 변경되었습니다.'
      });
      navigate(-1);
    },
    onError: () => {
      showToast({
        type: 'fail',
        message: '회원 설정 변경에 실패했습니다.'
      });
    }
  });

  const onPrev = () => {
    if (!personId) return;
    mutate({
      allowSelfScheduling,
      personId
    });
  };

  return (
    <PrevHeaderBarWithTitleTemplate onPrev={onPrev} title={'회원설정'}>
      <div className="px-20 py-28">
        <Section>
          <div style={{ display: 'flex', gap: '4px' }}>
            <div style={{ display: 'flex', gap: '2px' }}>
              <Text>수업 예약 링크 전송 여부</Text>
              <Required />
            </div>
            <Tooltip
              tooltipTrigger={
                <img
                  src="/images/help-24-dp-5-f-6368-fill-1-wght-400-grad-0-opsz-241.svg"
                  width={'16px'}
                  height={'16px'}
                />
              }
              position="bottom-center"
            >
              <div style={{ width: '260px' }}>
                <div
                  style={{
                    color: 'var(--gray-15---main-font, #EAE8ED)',
                    fontFamily: '"Pretendard Variable"',
                    fontSize: '12px',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    lineHeight: '16px',
                    textAlign: 'left'
                  }}
                >
                  수업 예약 링크란?
                </div>
                <div
                  style={{
                    color: 'var(--gray-100---sub-font, #8E899F)',
                    fontFamily: '"Pretendard Variable"',
                    fontSize: '12px',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    lineHeight: '16px',
                    textAlign: 'left'
                  }}
                >
                  회원이 직접 수업을 예약할 수 있도록 카카오톡 알림톡으로 예약
                  링크를 전송해드려요! (회원을 등록하시면 즉시 전송됩니다)
                </div>
              </div>
            </Tooltip>
          </div>
          <Tab
            defaultTab={initialAllowSelfScheduling ? '네' : '아니요'}
            tab={allowSelfSchedulingTab}
            onClick={tab => setAllowSelfScheduling(tab)}
          />
        </Section>
      </div>
    </PrevHeaderBarWithTitleTemplate>
  );
};
